/**
 * The Foundation Data v2 workstream a cited figure lives in — what the citation drawer's "Open in Foundation
 * Data" link opens.
 *
 * A curated row carries its workstream's `questionGroup` and `entityId` but not its `questionId`, and the
 * detail page is keyed on the question. `GET /years` lists every workstream with all three, so the match is
 * (year, workstream, entity). No match — a workstream since removed, or rows from before entities — gives
 * null rather than a guess, because opening the wrong workstream would show a different set of figures under
 * the cited one's name.
 *
 * Standalone (not in the `src/utils` barrel) so it can carry its own vitest.
 */
export function workstreamForFigure(years, row, year) {
  if (!Array.isArray(years) || !row || year == null) return null;
  const match = years.find(
    (candidate) =>
      Number(candidate.year) === Number(year) &&
      candidate.questionGroup === row.questionGroup &&
      String(candidate.entityId ?? "") === String(row.entityId ?? "")
  );
  return match?.questionId ? match : null;
}
